import type { IntakePayerRosterEntry } from '../../types';

/** Stable directory identity distinguishes payers sharing a primary ID; old rows keep their key. */
export function payerRosterRowId(
  payer: Pick<IntakePayerRosterEntry, 'payer_id' | 'stedi_id'>,
): string {
  return payer.stedi_id ? `stedi:${payer.stedi_id}` : payer.payer_id;
}
